
import { mapGetters } from "vuex";
import { getBrowser } from "@Common";
import {
  IconsBrowser,
  IconsSafari,
  IconsMore,
  ShadowArrow,
  ShadowIOSEn,
  ShadowIOSZh,
  ShadowAndroidEn,
  ShadowAndroidZh
} from "@Images/common";

export default {
  name: "DownloadAppShadow",
  data() {
    return {
      phoneImg: ShadowAndroidEn,
      browserIcon: IconsBrowser,
      shadowArrow: ShadowArrow,
      iconsMore: IconsMore,
      titleStep22: ""
    };
  },
  computed: {
    ...mapGetters(["GET_LOCAL"])
  },
  props: {
    autoHide: {
      default: false,
      type: Boolean
    },
    isFormula: {
      default: false,
      type: Boolean
    },
    showShadow: {
      default: false,
      type: Boolean
    }
  },
  mounted() {
    // 微信则弹窗提示在浏览器打开
    this.locale = this.GET_LOCAL;
    const { isiOS } = getBrowser();
    if (isiOS) {
      this.browserIcon = IconsSafari;
      this.phoneImg = this.locale === "zh" ? ShadowIOSZh : ShadowIOSEn;
    } else {
      this.phoneImg = this.locale === "zh" ? ShadowAndroidZh : ShadowAndroidEn;
    }
    this.titleStep22 = isiOS
      ? this.$t("downloadShadow.step22_iOS")
      : this.$t("downloadShadow.step22_Android");
  },
  methods: {
    hideGuide() {
      this.showShadow = false;
    },
    handleClick() {
      if (this.autoHide) {
        this.$emit("close");
        this.hideGuide();
      }
    }
  }
};
